export default __webpack_public_path__ + "media/images/backgrounds/pumpkins-cropped-1935707d9d81d8404d27cecdf62d46bc.svg";